import { useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { getCommonRequests, getCommonRequestsYears } from './common-requests.api';

export const useCommonRequestsQuery = (
  client_id: string,
  company_id: string,
  limit: number,
  page: number,
  year: string,
  month: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
) => {
  return useQuery({
    queryKey: [
      'common-requests',
      client_id,
      company_id,
      limit,
      page,
      year,
      month,
      orderBy,
      orderDirection,
    ],
    queryFn: () =>
      getCommonRequests(client_id, company_id, limit, page, year, month, orderBy, orderDirection),
  });
};

export const useCommonRequestsYearsQuery = () => {
  return useQuery({
    queryKey: ['common-requests-years'],
    queryFn: () => getCommonRequestsYears(),
  });
};
